import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

const customContentStyle = {
  width: "100%",
  maxWidth: "none",
};

export default function Profilepassword() {
  const [state, setState] = useState({
    password: "",
    password2: "",
    confirm_password: "",
    errorMessage: "",
    errorMessage1: "",
    handleChange: false,
  });

  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  const handleEditChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const Submit = (e) => {
    e.preventDefault();
    const login = {
      email: localStorage.getItem("email").toString(),
      password: state.password,
    };
    fetch(`${process.env.REACT_APP_API_URL}/auth/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(login),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.tokens && data.email && data.username) {
          localStorage.setItem("user", data.username);
          localStorage.setItem("email", data.email);
          localStorage.setItem("token", data.tokens.access);
          handleClickOpen1();
        } else {
          if (data.password) {
            setState({ errorMessage: data.password[0] });
          } else if (data.detail) {
            setState({ errorMessage: data.detail });
          } else {
            setState({ errorMessage: data.detail });
          }
        }
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem("token");
        if (error.code) {
          window.location.href = "/access_denied";
        } else {
          window.location.href = "/something_went_wrong";
        }
      });
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (state.confirm_password !== state.password2) {
      setState({ errorMessage1: "The passwords doesn't match" });
    } else {
      const usrprofile = {
        username: "",
        password: state.password2,
        groups: "",
        organization_name: "",
        address: "",
      };
      fetch(
        `${process.env.REACT_APP_API_URL}/api/user_management/editprofile`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(usrprofile),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          window.location.reload();
        });
      window.location.reload();
    }
  };

  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickOpen1 = () => {
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };

  function refreshPage() {
    window.location.reload();
  }

  return (
    <div>
      {localStorage.getItem("google") === "google" ? (
        <React.Fragment>
          <Tooltip
            title="Google sign-in users cannot change the password"
            arrow
          >
            <span>
              <Button
                color="primary"
                variant="contained"
                disabled
                sx={{
                  mt: "30px",
                  width: "80%",
                  borderRadius: "50px",
                  px: 3,
                  py: 1,
                }}
              >
                Change Password
              </Button>
            </span>
          </Tooltip>
          <Tooltip
            title="As you are using a Google account, you can't change your password"
            arrow
          >
            <IconButton
              sx={{
                color: "white",
                borderRadius: "50px",
                mt: "29px",
              }}
              size="small"
              data-toggle="collapse"
            >
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      ) : (
        <Tooltip title="Change password" arrow>
          <Button
            color="primary"
            variant="contained"
            onClick={handleClickOpen}
            sx={{ borderRadius: "50px", px: 3, py: 1 }}
          >
            Change Password
          </Button>
        </Tooltip>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        contentStyle={customContentStyle}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <Box>
            {state.errorMessage && visible && (
              <Alert 
                severity="error"
                onClose={onDismiss}
                sx={{
                  mb: 2,
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  fontFamily: "sans-serif",
                }}
              >
                {state.errorMessage}
              </Alert>
            )}
          </Box>
          <Box component="form" role="form">
            <DialogTitle
              sx={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "810",
                color: "rgb(48, 68, 115)",
                fontFamily: "sans-serif",
                lineHeight: "4.5rem",
              }}
            >
              Current Password
            </DialogTitle>
            <Box sx={{ marginBottom: "2.5rem" }}>
              <TextField
                autoFocus
                margin="dense"
                id="password"
                name="password"
                placeholder="password"
                type="password"
                inputProps={{ maxLength: 12 }}
                fullWidth
                variant="outlined"
                value={state.password}
                onChange={handleEditChange}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button
              color="secondary"
              variant="contained"
              onClick={refreshPage}
              sx={{ borderRadius: "50px", px: 3, py: 1 }}
            >
              Cancel
            </Button>
          </Tooltip>

          <Tooltip title="Confirm" arrow>
            <Button
              color="primary"
              type="submit"
              variant="contained"
              onClick={Submit}
              sx={{ borderRadius: "50px", px: 3, py: 1 }}
            >
              Confirm
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open1}
        onClose={handleClose1}
        contentStyle={customContentStyle}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <Box>
            {state.errorMessage1 && visible && (
              <Alert 
                severity="error"
                onClose={onDismiss}
                sx={{
                  mb: 2,
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  fontFamily: "sans-serif",
                }}
              >
                {state.errorMessage1}
              </Alert>
            )}
          </Box>
          <Box component="form" role="form">
            <DialogTitle
              sx={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "810",
                color: "rgb(48, 68, 115)",
                fontFamily: "sans-serif",
                lineHeight: "4.5rem",
              }}
            >
              Set New Password
            </DialogTitle>
            <Box sx={{ marginBottom: "2.5rem" }}>
              <TextField
                autoFocus
                margin="dense"
                placeholder="Password"
                type="password"
                fullWidth
                variant="outlined"
                id="password2"
                name="password2"
                value={state.password2}
                onChange={handleEditChange}
              />
              <TextField
                margin="dense"
                placeholder="Confirm Password"
                type="password"
                inputProps={{ maxLength: 12 }}
                fullWidth
                variant="outlined"
                id="confirm_password"
                name="confirm_password"
                value={state.confirm_password}
                onChange={handleEditChange}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleClose1}
              sx={{ borderRadius: "50px", px: 3, py: 1 }}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Confirm" arrow>
            <Button
              color="primary"
              type="submit"
              variant="contained"
              onClick={HandleSubmit}
              sx={{ borderRadius: "50px", px: 3, py: 1 }}
            >
              Confirm
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );
}